import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/rahreivee/emagyl.ro/components/legal/LegalContent.jsx");
;
import(/* webpackMode: "eager" */ "/home/rahreivee/emagyl.ro/node_modules/next/dist/client/link.js");
